export default {
    newPageCreateFile: "Creating file",
    globalConfirm: "OK",
    globalCancel: "Cancel",
    globalStyle: "Style",
    globalColor: "Color",
    globalLine: "Line",
};
